import React from 'react';

import { FieldTitle } from '../../common';

const texts = {
  riskHints: {
    headline1: {
      quirinprivatbank: 'Historische Rendite',
      consultant: 'Renditewunsch',
      quirion: 'Dein Renditewunsch'
    },
    headline2: {
      quirinprivatbank: 'Historisches Risiko',
      consultant: 'Risiko',
      quirion: 'Dein Risiko'
    },
    headline3: {
      quirinprivatbank: 'Längster Verlustzeitraum',
      consultant: 'Längster Verlustzeitraum',
      quirion: 'Längster Verlustzeitraum'
    },
    headline4: {
      quirinprivatbank: 'Anlagehorizont',
      consultant: 'Anlagehorizont',
      quirion: 'Dein Anlagehorizont'
    },
    description1: {
      quirinprivatbank: 'Durchschnittliche Bruttorendite pro Jahr bezogen auf den Anlagehorizont',
      consultant: 'Durchschnittliche Bruttorendite pro Jahr bezogen auf den Anlagehorizont',
      quirion:
        'Durchschnittliche Bruttorendite über risikolosem Zins pro Jahr (EONIA) bezogen auf den Anlagehorizont'
    },
    description2: {
      quirinprivatbank: 'Max. Verlust zum Höchststand',
      consultant: 'Max. Verlust zum Höchststand',
      quirion: 'Max. Verlust zum Höchststand'
    },
    description3: {
      quirinprivatbank: '',
      consultant: '',
      quirion: ''
    },
    description4: {
      quirinprivatbank: 'Aus Risikogesichtspunkten mindestens empfohlene Anlagedauer',
      consultant: 'Aus Risikogesichtspunkten mindestens empfohlene Anlagedauer',
      quirion:
        'Mindestzeitraum, in dem das anzulegende Vermögen aus heutiger Sicht nicht für andere Anschaffungen benötigt wird'
    },
    'hint-a': {
      value1: {
        quirinprivatbank: '< 2,5 %',
        consultant: '< 2,5 %',
        quirion: '< 4 %'
      },
      value2: {
        quirinprivatbank: '7 %',
        consultant: '7 %',
        quirion: '2,4 %'
      },
      value3: {
        quirinprivatbank: '13 Monate',
        consultant: '13 Monate',
        quirion: '11 Monate'
      },
      value4: {
        quirinprivatbank: 'unter 1 Jahr',
        consultant: 'unter 1 Jahr',
        quirion: 'unter 1 Jahr'
      }
    },
    'hint-b': {
      value1: {
        quirinprivatbank: '2,5 - 3,5 %',
        consultant: '2,5 - 3,5 %',
        quirion: '4 - 5,2 %'
      },
      value2: {
        quirinprivatbank: '20,8 %',
        consultant: '20,8 %',
        quirion: '15,3 %'
      },
      value3: {
        quirinprivatbank: '40 Monate',
        consultant: '40 Monate',
        quirion: '26 Monate'
      },
      value4: {
        quirinprivatbank: '1 - 3 Jahre',
        consultant: '1 - 3 Jahre',
        quirion: '1 - 3 Jahre'
      }
    },
    'hint-c': {
      value1: {
        quirinprivatbank: '3,5 - 4,5 %',
        consultant: '3,5 - 4,5 %',
        quirion: '5,3 - 6,2 %'
      },
      value2: {
        quirinprivatbank: '32,7 %',
        consultant: '32,7 %',
        quirion: '28,6 %'
      },
      value3: {
        quirinprivatbank: '46 Monate',
        consultant: '46 Monate',
        quirion: '37 Monate'
      },
      value4: {
        quirinprivatbank: '3 - 4 Jahre',
        consultant: '3 - 4 Jahre',
        quirion: '3 - 5 Jahre'
      }
    },
    'hint-d': {
      value1: {
        quirinprivatbank: '4,5 - 5,5 %',
        consultant: '4,5 - 5,5 %',
        quirion: '6,3 - 7,1 %'
      },
      value2: {
        quirinprivatbank: '43 %',
        consultant: '43 %',
        quirion: '40,4 %'
      },
      value3: {
        quirinprivatbank: '62 Monate',
        consultant: '62 Monate',
        quirion: '67 Monate'
      },
      value4: {
        quirinprivatbank: '4 - 5 Jahre',
        consultant: '4 - 5 Jahre',
        quirion: '5 - 7 Jahre'
      }
    },
    'hint-e': {
      value1: {
        quirinprivatbank: '> 5,5 %',
        consultant: '> 5,5 %',
        quirion: '> 7,1 %'
      },
      value2: {
        quirinprivatbank: '> 50 %',
        consultant: '> 50 %',
        quirion: '> 50 %'
      },
      value3: {
        quirinprivatbank: '68 Monate',
        consultant: '68 Monate',
        quirion: '76 Monate'
      },
      value4: {
        quirinprivatbank: '> 5 Jahre',
        consultant: '> 5 Jahre',
        quirion: '> 7 Jahre'
      }
    }
  }
};

const ReadinessToAssumeRisk = ({ internalTitle, formId, required, ...props }) => {
  const contentArticleFormId = `content_article_form-${props.contentArticleFormId}`;
  const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;
  // TODO: get quirinprivatbank, consultant or quirion from context/params
  const bank = 'quirinprivatbank';
  const letters = ['a', 'b', 'c', 'd', 'e'];

  return (
    <div>
      <div className="hint">
        Kreuzen Sie bitte den entsprechenden Buchstaben an. Für Erklärungen den Mauszeiger über A-E
        bewegen.
      </div>
      {required && <div className="hint required">* Pflichtauswahl</div>}

      <div className={`formgroup inputs risks-container ${internalTitle}`}>
        <div className="risks clearfix">
          {letters.map((letter) => {
            return (
              <div className={`risk risk-${letter}`} key={`risk-${letter}`}>
                <input
                  type="radio"
                  value={letter.toUpperCase()}
                  name={internalTitle}
                  id={`${forId}-${letter}`}
                  required={required}
                  data-parsley-error-message="bitte auswählen"
                  className="hidden-risk-radio"
                  tabIndex="30"
                />
                <label htmlFor={`${forId}-${letter}`}>
                  <span className="diamond-outer">
                    <span className="diamond-inner"></span>
                  </span>
                  <div className={`box box-${letter}`}>{letter.toUpperCase()}</div>
                </label>
              </div>
            );
          })}
        </div>

        <div className="risk-hints closed">
          {letters.map((letter) => {
            return (
              <div className={`risk-hint-${letter}`} key={`risk-hint-${letter}`}>
                <table>
                  <tbody>
                    {[...Array(4)].map((_, i) => (
                      <tr key={`risk-hint-${letter}-${i}`}>
                        <td>
                          <strong>{`${texts.riskHints[`headline${i + 1}`][bank]}`}</strong>
                          <p className={`${i == 3 ? 'last-p' : ''}`}>
                            {`${texts.riskHints[`description${i + 1}`][bank]}`}
                          </p>
                        </td>
                        <td>
                          <div>{`${texts.riskHints[`hint-${letter}`][`value${i + 1}`][bank]}`}</div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

ReadinessToAssumeRisk.propTypes = {
  internalTitle: React.PropTypes.string,
  formId: React.PropTypes.number,
  required: React.PropTypes.bool,
  contentArticleFormId: React.PropTypes.number
};

export default ReadinessToAssumeRisk;



// WEBPACK FOOTER //
// ./components/forms/depotCheck/readinessToAssumeRisk.js